import {
  openMsgModal,
  openSubModal,
  formatYYYYMMDD,
  convertSnakeCace,
  convertCamelCace,
} from '@/common/Common.js'
import { MSG_TYPE, LIMITED_MAX_MIN } from '@/common/const.js'
import PlanningFlagService from './PlanningFlagService'
import _ from 'lodash'

export function init(obj) {
  if (obj.selectedPlanningOrderIds.length > 0) {
    obj.$store.dispatch('init/setServiceLoading')
    PlanningFlagService.findDetailDelivery(
      obj.selectedPlanningOrderIds[0],
      obj.selectedPlanningOrderIds
    )
      .then(
        (response) => {
          var getDatas = _.cloneDeep(response.data.dtoList)
          var datas = convertSnakeCace(getDatas)

          obj.tableItems = datas
          obj.packUpInfoList.tableItems = datas //save oridata

          obj.displayData = response.data.dtoData
          obj.packUpInfoList.departureBeginDate =
            obj.displayData.departureBeginDate
          obj.packUpInfoList.arrivalBeginDate = obj.displayData.arrivalBeginDate
          obj.packUpInfoList.blockCode = obj.displayData.blockCode
          obj.packUpInfoList.planningGroupName =
            obj.displayData.planningGroupName
          obj.packUpInfoList.assignVehicleId = obj.displayData.assignVehicleId
          obj.packUpInfoList.assignVehicleCode =
            obj.displayData.assignVehicleCode
          obj.packUpInfoList.assignVehicleName =
            obj.displayData.assignVehicleName
          obj.packUpInfoList.vehicleCategoryName =
            obj.displayData.vehicleCategoryName
          obj.packUpInfoList.vehicleModelName = obj.displayData.vehicleModelName
          obj.packUpInfoList.volume = obj.displayData.volume
          obj.packUpInfoList.weight = obj.displayData.weight

          obj.oriData = _.cloneDeep(obj.packUpInfoList)

          //検索結果の配車オーダに全て同じ荷纏めIDが設定されている場合は下記を行う
          //検索条件の指定車両（車両名～車型）に結果を表示する
          //荷纏め解除ボタン(F8ボタン)を活性にする
          var bKaijo = true
          var nHnmtmId = 0
          obj.tableItems.forEach((element) => {
            if (element.delivery_packup_flag == 0) {
              bKaijo = false
              return
            }
            nHnmtmId = obj.displayData.deliveryPackupId
            if (nHnmtmId != element.delivery_packup_id) {
              bKaijo = false
              return
            }
          }) //荷纏めフラグ

          if (nHnmtmId > 0 && bKaijo == true) {
            obj.packupDisabled = false //「配送纏め解除」ボタン活性化
          } else {
            obj.packupDisabled = true
          }
          // 「解除待ち」情報がある場合、解除ボタン以外は非活性とする。
          // 遷移元では「解除待ち」が含まれている場合は
          // 選択している全件が「解除待ち」という仕様である。
          obj.registDisabled = false //「配送纏め解除」ボタン非活性化
          obj.rowDeleteDisabled = false //「配送纏め解除」ボタン非活性化
        },
        (e) => {
          var msg
          if (e.response == undefined) {
            msg = obj.$store.getters['init/getMessage']('YZ00MG946E')
          } else {
            msg = e.response.data.message
          }
          // エラーモーダル表示
          openMsgModal(obj, MSG_TYPE.E, msg)
        }
      )
      .finally(() => {
        obj.$store.dispatch('init/setServiceUnLoading')
      })
  }
}

export function clear(obj) {
  obj.packUpInfoList = _.cloneDeep(obj.oriData)
  obj.packUpInfoList.tableItems = _.cloneDeep(obj.oriData.tableItems)
  obj.tableItems = _.cloneDeep(obj.oriData.tableItems)
}

export function deleteRow(obj) {
  if (obj.selectedItem.length == 0) {
    openMsgModal(
      obj,
      MSG_TYPE.E,
      obj.$store.getters['init/getMessage']('YZ00MG969E')
    )
    return
  }

  // 配送纏めの行削除処理
  //１行選択
  obj.selectedItem.forEach((element) => {
    const index = obj.tableItems.indexOf(element)
    obj.tableItems.splice(index, 1)
  })
}

/**
 * 「登録」ボタン
 * @param {*} obj
 */
export function goRegister(obj) {
  // 行が２行以上存在するかどうかチェックする。エラー時はメッセージを出力する。
  if (obj.tableItems.length < 1) {
    // ２件以上の場所を指定してください。
    openMsgModal(
      obj,
      MSG_TYPE.E,
      obj.$store.getters['init/getMessage']('MB01S004_MG009E')
    )
    return
  }

  var camelPattern = convertCamelCace(obj.tableItems)

  let errorExist = false
  // 「荷纏め＝なし」
  if (camelPattern.length == 1) {
    // 纏められていないレコードの場合、2行以上レコードを選択してください。
    camelPattern.forEach((element) => {
      if (element.packupFlag == 0) {
        openMsgModal(
          obj,
          MSG_TYPE.I,
          obj.$store.getters['init/getMessage']('EB01S001_MG002E')
        )
        errorExist = true
        return
      }
    })
  }
  if (errorExist) return

  //データ上限値チェック
  var mNum = 0
  var mVol = 0
  var mWeight = 0
  camelPattern.forEach((element) => {
    mNum = mNum + element.quantity
    mVol = mVol + element.volume
    mWeight = mWeight + element.weight
    if (LIMITED_MAX_MIN.MAX < mNum) {
      openMsgModal(
        obj,
        MSG_TYPE.I,
        obj.$store.getters['init/getMessage']('EB03S001_MG001E', '数量', '登録')
      )
      errorExist = true
      return
    }
    if (LIMITED_MAX_MIN.MAX < mWeight) {
      openMsgModal(
        obj,
        MSG_TYPE.I,
        obj.$store.getters['init/getMessage']('EB03S001_MG001E', '質量', '登録')
      )
      errorExist = true
      return
    }
    if (LIMITED_MAX_MIN.MAX < mVol) {
      openMsgModal(
        obj,
        MSG_TYPE.I,
        obj.$store.getters['init/getMessage']('EB03S001_MG001E', '容量', '登録')
      )
      errorExist = true
      return
    }
  })
  if (errorExist) return

  // {0}処理を行います。よろしいですか？
  obj.registerMessage = obj.$store.getters['init/getMessage'](
    'YZ00MG994Q',
    obj.resultControlInfo.register.label
  )
  openSubModal(obj, 'planning-orderPackup-register-modal')
}

export function register(obj) {
  obj.$bvModal.hide('planning-orderPackup-register-modal')

  var camelPattern = convertCamelCace(obj.tableItems)

  obj.displayData.departureBeginDate = formatYYYYMMDD(
    obj,
    obj.displayData.departureBeginDate
  )
  obj.displayData.arrivalBeginDate = formatYYYYMMDD(
    obj,
    obj.displayData.arrivalBeginDate
  )
  obj.displayData.departureBeginDate = obj.packUpInfoList.departureBeginDate
  obj.displayData.arrivalBeginDate = obj.packUpInfoList.arrivalBeginDate
  obj.displayData.blockCode = obj.packUpInfoList.blockCode
  obj.displayData.planningGroupName = obj.packUpInfoList.planningGroupName
  obj.displayData.assignVehicleId = obj.packUpInfoList.assignVehicleId
  obj.displayData.assignVehicleCode = obj.packUpInfoList.assignVehicleCode
  obj.displayData.assignVehicleName = obj.packUpInfoList.assignVehicleName
  obj.displayData.vehicleCategoryName = obj.packUpInfoList.vehicleCategoryName
  obj.displayData.vehicleModelName = obj.packUpInfoList.vehicleModelName

  let registerList = {
    entryKind: null,
    dtoData: obj.displayData,
    dtoList: camelPattern,
  }

  PlanningFlagService.editDelivery(
    obj.packUpInfoList.planningOrderId,
    registerList
  ).then(
    () => {
      openMsgModal(
        obj,
        MSG_TYPE.I,
        obj.$store.getters['init/getMessage'](
          'YZ00MG995I',
          obj.resultControlInfo.register.label
        )
      )
      obj.$bvModal.hide('planning-packup-modal')
      obj.$emit('after-close-set')
    },
    (e) => {
      // エラーモーダル表示
      var msg
      if (e.response == undefined) {
        msg = obj.$store.getters['init/getMessage']('YZ00MG946E')
      } else {
        msg = e.response.data.message + e.response.data.messageDetail
      }
      openMsgModal(obj, MSG_TYPE.E, msg)
    }
  )
}

/**
 * 「配送纏め解除」ボタン
 * @param {*} obj
 */
export function goPackupCancel(obj) {
  // {0}処理を行います。よろしいですか？
  obj.registerMessage = obj.$store.getters['init/getMessage'](
    'YZ00MG994Q',
    obj.resultControlInfo.order_packup_cancel.label
  )
  openSubModal(obj, 'planning-orderPackup-cancel-modal')
}

/**
 * 「配送纏め解除」ボタン
 * @param {*} obj
 */
export function packupCancel(obj) {
  obj.$bvModal.hide('planning-orderPackup-cancel-modal')

  var camelPattern = convertCamelCace(obj.tableItems)

  obj.displayData.departureBeginDate = formatYYYYMMDD(
    obj,
    obj.displayData.departureBeginDate
  )
  obj.displayData.arrivalBeginDate = formatYYYYMMDD(
    obj,
    obj.displayData.arrivalBeginDate
  )
  obj.displayData.departureBeginDate = obj.packUpInfoList.departureBeginDate
  obj.displayData.arrivalBeginDate = obj.packUpInfoList.arrivalBeginDate
  obj.displayData.blockCode = obj.packUpInfoList.blockCode
  obj.displayData.planningGroupName = obj.packUpInfoList.planningGroupName
  obj.displayData.assignVehicleId = obj.packUpInfoList.assignVehicleId
  obj.displayData.assignVehicleCode = obj.packUpInfoList.assignVehicleCode
  obj.displayData.assignVehicleName = obj.packUpInfoList.assignVehicleName
  obj.displayData.vehicleCategoryName = obj.packUpInfoList.vehicleCategoryName
  obj.displayData.vehicleModelName = obj.packUpInfoList.vehicleModelName

  let packupCancelList = {
    entryKind: null,
    dtoData: obj.displayData,
    dtoList: camelPattern,
  }

  PlanningFlagService.cancelDelivery(
    obj.packUpInfoList.planningOrderId,
    packupCancelList
  ).then(
    () => {
      openMsgModal(
        obj,
        MSG_TYPE.I,
        obj.$store.getters['init/getMessage'](
          'YZ00MG995I',
          obj.resultControlInfo.order_packup_cancel.label
        )
      )
      obj.$bvModal.hide('planning-packup-modal')
      obj.$emit('after-close-set')
    },
    (e) => {
      // エラーモーダル表示
      var msg
      if (e.response == undefined) {
        msg = obj.$store.getters['init/getMessage']('YZ00MG946E')
      } else {
        msg = e.response.data.message + e.response.data.messageDetail
      }
      openMsgModal(obj, MSG_TYPE.E, msg)
    }
  )
}
